import React from "react";
import DDados from "../habitese.ddados";
import autoBind from "react-autobind";
import BaseComponent, { connect } from "@common/components/base.component";
import habiteseActions from "../store/habitese.actions";
import HabiteseDadosForm from "../components/habiteseDados.form";

class Container extends BaseComponent {
  constructor(props) {
    super(props, DDados);
    autoBind(this);
  }
  onPrintReport() {
    this.props.habiteseActions.getImprimirHabitese();
  }

  render() {
    return <HabiteseDadosForm onPrintReport={this.onPrintReport} prefix="V" title="Habite-se"/>;
  }
}

export default connect({
  actions: {
    habiteseActions
  }
})(Container);
